/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { Row, Col, Container } from 'react-bootstrap';
import Carousel from 'react-multi-carousel';
import { Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { useUserStore, useCompanyStore } from 'stores';
//ui
import { AiOutlineTwitter } from 'react-icons/ai';
import { GrFacebookOption } from 'react-icons/gr';
import { BiCheckCircle } from 'react-icons/bi';
import { FaRegTimesCircle, FaShippingFast, FaTrophy } from 'react-icons/fa';
import { HiMail } from 'react-icons/hi';
//api
import { getDetailProduct, getRelatedProduct } from 'api/products';
import { getBookDetail, getBookAvailableLibraries } from 'api/libros';
import { saveFavoriteProductUser, deleteFavoriteProductUser } from 'api/users';
//helpers
import { truncate, checkEmpty, capitalize } from '../../helpers';
//utils
import { cleanHTML } from '../../utils';
import { formatCurrency } from 'utils/currencyFormatter';
import PriceWithDiscount from 'components/priceWithDiscount/PriceWithDiscount';
// CONSTANTS
import { responsive } from '../../constants';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
import { useAddToCartWithBookCondition } from 'utils/customHooks/useAddToCartWithBookCondition';
import BookConditionChoiceModal from 'components/cart/BookConditionChoiceModal';
// components
import CoverImage from 'components/coverImage/CoverImage';
import ItemList from 'components/itemList/item';
import AvailableLibraries from 'components/availableLibraries';
import Head from 'components/metatags_helmet/metatags';
import AuthorsByName from 'components/authorsByName';
import NoResults from 'components/userzone/NoResults';
import Button from 'components/userzone/buttons/ButtonCustom';
//styles
import 'react-multi-carousel/lib/styles.css';
import '../awardWinningBooksPage/awardWinningBooksPage.scss';
import './detail.scss';
//images
import imageAvailableBook from 'assets/img/booktores_available.png';

function BookDetail() {
  const { t } = useTranslation(['detalle', 'cart']);
  const { isLogged } = useUserStore();
  const { name } = useCompanyStore();
  const { loading: cartLoading, pendingProduct, requestAdd, confirmCondition, closeModal } =
    useAddToCartWithBookCondition();
  
  const [productDetail, setProductDetail] = useState('');
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [isBookFavorited, setIsBookFavorited] = useState({ status: false, id: null });
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [fullDescription, setFullDescription] = useState(false);
  const [restockSubscriptionStatus, setRestockSuscriptionStatus] = useState(null);
  const [availableLibraries, setAvailableLibraries] = useState([]);
  const [showAvailableBookstores, setShowAvailableBookstores] = useState(false);
  const [loadingRelatedProducts, setLoadingRelatedProducts] = useState(true);
  const [noResults, setNoResults] = useState(false);
  const { assignedLibrary } = useAssignedLibrary();

  const { pathname } = useLocation();
  // URL para compartir (puede incluir query params para compatibilidad)
  const shareUrl = window.location.href;
  // URL canónica sin query parameters para SEO
  const canonicalUrl = typeof window !== 'undefined' 
    ? `${window.location.origin}${pathname}` 
    : shareUrl;
  let { id } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
    const type = pathname.split('/')[2];
    handleDetailProduct(type);
    handleRelatedProducts();
  }, [id]);

  useEffect(() => {
    const getAvailableBookstores = async () => {
      try {
        const { status, data } = await getBookAvailableLibraries(id);
        if (status === 200) {
          setAvailableLibraries(data);
        }
      } catch (error) {
        console.error(error);
      }
    };
    if (showAvailableBookstores) getAvailableBookstores();
  }, [showAvailableBookstores]);

  const properties = {
    processLan() {
      if (!productDetail.languages) return null;
      const lans = productDetail.languages
        .map((val, i) => {
          return val.nombre;
        })
        .join(',');
      return lans.length >= 1 ? lans : 'N/A';
    },
    processEncuadernacion(product) {
      if (!product.encuadernacion) return null;
      const bookBinding = product.encuadernacion
        .map((val, i) => {
          return `${val.descripcion}`;
        })
        .join(',');
      return bookBinding;
    },
  };

  const checkDetailEpCallByType = (type) => {
    if (type === 'libro') {
      return getBookDetail(id);
    } else {
      return getDetailProduct(id);
    }
  };

  const handleSEOTitle = (type, title, authorName) => {
    if (type === 'merchandising') {
      return `merchandising ${title}`;
    } else if (type === 'film') {
      return `${t('movie')} ${title}`;
    } else {
      // Mejorar título SEO para libros: incluir autor y nombre de librería
      const authorPart = authorName ? ` - ${authorName}` : '';
      return `${title}${authorPart} | ${name}`;
    }
  };

  const handleSEODescription = (data) => {
    if (data.type === 'film') {
      const editorial = data.editorial ? data.editorial.nombre_fiscal : '';
      return `${t('themovie')} ${data.title} ${t('ofthestudy')} ${editorial}, ${t('saleonline')} ${name}.`;
    } else if (data.type === 'merchandising') {
      return `${t('fanof')} ${title}, ${t('in')} ${name} ${t('merchadisingproducts')}`;
    } else {
      const autor = data?.authors[0] ? data?.authors[0].nombre_autor : '';
      return `${t('thebook')} ${data.title} ${t('oftheauthor')} ${autor} ${t('with')} EAN ${data.ean}, ${t('saleonline')} ${name}.`;
    }
  };

  const handleDetailProduct = async (type) => {
    try {
      const { status, data } = await checkDetailEpCallByType(type);
      if (status === 200) {
        setIsBookFavorited({ status: data?.saved.favorite, id: data?.saved.id || null });
        setProductDetail(data);
        const authorName = data?.authors?.[0]?.nombre_autor || '';
        setTitle(handleSEOTitle(data?.type, data?.title, authorName));
        setDescription(handleSEODescription(data));
      } else {
        setNoResults(true);
      }
    } catch (error) {
      console.error('%c -handleDetailProduct- ERROR', error);
    }
  };

  const handleRelatedProducts = async () => {
    const fields = ['id', 'title', 'url', 'image', 'authors', 'type', 'price', 'discount', 'has_stock', 'encuadernacion', 'has_used', 'has_newbalance'].join(',');
    try {
      const { status, data } = await getRelatedProduct(id, { fields: fields });
      if (status === 200) {
        setRelatedProducts(data);
      }
    } catch (error) {
      console.error('%c -handleRelatedProducts- ERROR', error);
    } finally {
      setLoadingRelatedProducts(false);
    }
  };

  const addBookToFavoritesHandler = async () => {
    const { status, data } = await saveFavoriteProductUser({ product: productDetail.id });
    if ([200, 201].includes(status)) {
      setIsBookFavorited((prevState) => ({
        ...prevState,
        status: true,
        id: data?.id,
      }));
    }
  };
  const removeBookFromFavoritesHandler = async () => {
    const { status } = await deleteFavoriteProductUser(isBookFavorited.id);
    if (status === 204) {
      setIsBookFavorited({ status: false, id: null });
    }
  };

  useEffect(() => {
    //!   PARA QUE ES? -REVISAR-
    setRestockSuscriptionStatus(undefined);
  }, [productDetail]); //selectedItem

  const closeOverlay = () => {
    setShowAvailableBookstores(!showAvailableBookstores);
  };

  // Función para limpiar URL de imagen removiendo parámetros de autenticación AWS S3
  const cleanImageUrl = (url) => {
    if (!url) return '';
    try {
      // Remover todos los parámetros de query string (especialmente los de AWS S3)
      const urlWithoutParams = url.split('?')[0];
      return urlWithoutParams;
    } catch (error) {
      console.error('Error al limpiar URL de imagen:', error);
      return url;
    }
  };

  // Generar datos estructurados JSON-LD para Schema.org Book
  const generateStructuredData = () => {
    // Verificar que sea un libro (puede ser 'libro' o 'book')
    const isBook = productDetail?.type === 'libro' || productDetail?.type === 'book' || pathname.includes('/libro/');
    if (isEmpty(productDetail) || !isBook) {
      return null;
    }

    const authorNames = productDetail?.authors?.map(author => author.nombre_autor) || [];
    const publisherName = productDetail?.editorial?.nombre_fiscal || name;
    // Limpiar URL de imagen para remover credenciales de AWS S3
    const bookImage = cleanImageUrl(productDetail?.image) || '';
    // Usar URL canónica sin query parameters para structured data
    const bookUrl = canonicalUrl;
    const isbn = productDetail?.ean || '';
    const publicationDate = productDetail?.publication_date || '';
    const numberOfPages = productDetail?.num_paginas || '';
    const language = productDetail?.languages?.[0]?.nombre || 'es';
    const bookBinding = properties.processEncuadernacion(productDetail) || '';
    const inStock = productDetail?.has_stock || false;
    const price = productDetail?.price || '';
    const currency = 'EUR';

    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Book",
      "name": productDetail.title,
      "author": authorNames.length > 0 ? authorNames.map(authorName => ({
        "@type": "Person",
        "name": authorName
      })) : undefined,
      "publisher": {
        "@type": "Organization",
        "name": publisherName
      },
      "image": bookImage,
      "url": bookUrl,
      "description": cleanHTML(productDetail?.summary || description),
      "isbn": isbn || undefined,
      "datePublished": publicationDate || undefined,
      "numberOfPages": numberOfPages ? parseInt(numberOfPages) : undefined,
      "inLanguage": language,
      "bookFormat": bookBinding ? {
        "@type": "BookFormatType",
        "name": bookBinding
      } : undefined,
      "offers": {
        "@type": "Offer",
        "availability": inStock ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
        "price": price ? parseFloat(price) : undefined,
        "priceCurrency": price ? currency : undefined,
        "url": bookUrl,
        "seller": {
          "@type": "Organization",
          "name": name
        }
      }
    };

    // Eliminar propiedades undefined
    Object.keys(structuredData).forEach(key => {
      if (structuredData[key] === undefined) {
        delete structuredData[key];
      }
    });

    if (structuredData.offers) {
      Object.keys(structuredData.offers).forEach(key => {
        if (structuredData.offers[key] === undefined) {
          delete structuredData.offers[key];
        }
      });
      // Si offers está vacío, eliminarlo
      if (Object.keys(structuredData.offers).length === 0) {
        delete structuredData.offers;
      }
    }

    return structuredData;
  };

  const structuredData = !isEmpty(productDetail) ? generateStructuredData() : null;

  return (
    <div className="container-fluid justify-content-center pt-5 overflow-hidden mainDiv">
      <Head 
        description={description} 
        title={title}
        image={productDetail?.image}
        ogImage={productDetail?.image}
        ogTitle={title}
        ogDescription={description}
        ogUrl={canonicalUrl}
        ogType="book"
        canonical={canonicalUrl}
      />
      {structuredData && (
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(structuredData)}
          </script>
        </Helmet>
      )}
      {!noResults ? (
        <Container fluid className="justify-content-center px-0">
          <Row className="justify-content-center px-0">
            <Col lg={9} className="pl-3">
              <Row className="px-0">
                <Col md={4} lg={4} className="mb-2">
                  <div className="d-flex">
                    <div className="position-relative">
                      {productDetail?.is_awarded && (
                        <div className="trophyDivNew">
                          <FaTrophy />
                        </div>
                      )}
                      <div className="img-container img-container-detail">
                        {!isEmpty(productDetail) && <CoverImage title={productDetail.title} src={productDetail.image} />}
                        {productDetail?.is_novelty && (
                          <div className="label-text-container novelty">
                            <p className="label-text">{t('novelty').toUpperCase()}</p>
                          </div>
                        )}
                        {productDetail?.recommended && (
                          <div className="label-text-container recommended">
                            <p className="label-text">
                              {productDetail?.bookstore_recommender?.name
                                ? t('bookstoreRecommender', { ns: 'detalle', name: productDetail.bookstore_recommender.name }).toUpperCase()
                                : t('libreriaRecomienda', { ns: 'detalle' }).toUpperCase()}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="socialDiv">
                    <p>{t('compartir')}: </p>
                    <a
                      href={`https://facebook.com/sharer/sharer.php?u=${shareUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className="icon">
                        <GrFacebookOption />
                      </div>
                    </a>
                    <a
                      href={`https://twitter.com/intent/tweet?text=Libro%20recomendado%3A%0A${shareUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className="icon">
                        <AiOutlineTwitter />
                      </div>
                    </a>
                    <div className="icon">
                      <HiMail />
                    </div>
                  </div>
                </Col>
                <Col md={6} lg={8} className="pl-3">
                  {productDetail?.materia_ibic?.length > 0 && (
                    <Row md={12} className="p-0">
                      <Col md={12} className="mb-1">
                        <div className="detail-subjects d-flex flex-wrap align-items-center">
                          {productDetail.materia_ibic.map((item, i) => (
                            <React.Fragment key={item?.id ?? i}>
                              <Link
                                className="detail-subjects__link"
                                to={`/${assignedLibrary}/lista/materias?ibic=${item.id}&title=${encodeURIComponent(item.descripcion)}`}
                              >
                                {capitalize(item?.descripcion)}
                              </Link>
                              {i < productDetail.materia_ibic.length - 1 && (
                                <span className="detail-subjects__sep">|</span>
                              )}
                            </React.Fragment>
                          ))}
                        </div>
                      </Col>
                    </Row>
                  )}
                  <Row md={12} className="p-0">
                    <Col md={12}>
                      <h1 className="titleItem">{productDetail?.title}</h1>
                    </Col>
                  </Row>
                  <Row md={12}>
                    <Col md={12}>
                      <h3 className="autor-item mt-1 d-flex">
                        {productDetail?.authors && (
                          <AuthorsByName
                            elements={productDetail?.authors}
                            originDetail={pathname.includes('/libro/')}
                          />
                        )}
                      </h3>
                    </Col>
                  </Row>
                  <Row md={12} className="description-item pt-3">
                    <Col md={12}>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: checkEmpty(productDetail)
                            ? fullDescription
                              ? cleanHTML(productDetail?.summary)
                              : truncate(cleanHTML(productDetail?.summary), 400)
                            : '',
                        }}
                      />
                    </Col>
                    {productDetail?.summary?.length > 400 && (
                      <button
                        className="mb-3 btn btn-link p-0 style-link"
                        onClick={() => {
                          fullDescription ? setFullDescription(false) : setFullDescription(true);
                        }}
                      >
                        {fullDescription ? t('watchLess') : t('watchMore')}
                      </button>
                    )}
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col lg={3} className="pr-2 buttonsCol">
              <Row>
                <Col lg={12}>
                  {(productDetail?.has_used || productDetail?.has_newbalance) && (
                    <div className="w-100 d-flex justify-content-end flex-wrap gap-2 mb-2 detail-book-condition-badges">
                      {!!productDetail?.has_used && (
                        <span className="detail-book-condition-badge">{t('bookConditionUsed')}</span>
                      )}
                      {!!productDetail?.has_newbalance && (
                        <span className="detail-book-condition-badge">{t('bookConditionLikeNew')}</span>
                      )}
                    </div>
                  )}
                </Col>
              </Row>
              <Row>
                <Col lg={12} className={productDetail?.discount > 0 ? 'd-flex flex-column align-items-end' : 'd-flex justify-content-end'}>
                  {productDetail?.discount > 0 ? (
                    <>
                      {productDetail?.price && (
                        <span className="mb-1">
                          <PriceWithDiscount price={productDetail.price} discount={productDetail.discount} showPercent={false} />
                        </span>
                      )}
                      <p className="mb-0 stock-text align-self-end top-0">
                        {productDetail.has_stock
                          ? (productDetail.manual_stock > 0
                            ? `${productDetail.manual_stock} ${t('enStock')}`
                            : t('enStock'))
                          : t('sinStock')}
                      </p>
                    </>
                  ) : (
                    <>
                      <p className="mx-3 mb-0 stock-text">
                        {productDetail.has_stock
                          ? (productDetail.manual_stock > 0
                            ? `${productDetail.manual_stock} ${t('enStock')}`
                            : t('enStock'))
                          : t('sinStock')}
                      </p>
                      {productDetail?.price && (
                        <span>
                          <PriceWithDiscount price={productDetail.price} discount={productDetail.discount} />
                        </span>
                      )}
                    </>
                  )}
                </Col>
              </Row>
              <Row className="buttonRow">
                <Col lg={12}>
                  <Button className={`${!productDetail?.has_stock ? 'noStock' : 'inStock'} pe-none`}>
                    {properties.processEncuadernacion(productDetail) !== null &&
                    properties.processEncuadernacion(productDetail) !== ''
                      ? properties.processEncuadernacion(productDetail) + ' '
                      : 'Libro físico '}
                    {productDetail?.price && (
                      <PriceWithDiscount price={productDetail.price} discount={productDetail.discount} />
                    )}
                    {productDetail.has_stock ? <BiCheckCircle /> : <FaRegTimesCircle />}
                  </Button>
                </Col>
              </Row>

              {productDetail?.has_stock && (
                <Row className="buttonRow">
                  <Col lg={12} className="">
                    <Button
                      onClick={() => requestAdd(productDetail)}
                      className="mt-3 addCart"
                      loading={cartLoading}
                    >
                      {t('anadirCesta')}
                    </Button>
                  </Col>
                </Row>
              )}
              <Row>
                {productDetail?.available && (
                  <Col lg={12} className="d-flex mt-1 shippingTime">
                    <p>
                      <FaShippingFast className="mx-2" />
                      {productDetail?.available?.text}
                    </p>
                  </Col>
                )}
              </Row>
            {/*   {productDetail?.has_stock && (
                <Col lg={12} className="container-available-book">
                  <img src={imageAvailableBook} alt="Bookstore available" className="image-available-book" />
                  <div className="available-book" onClick={() => setShowAvailableBookstores(!showAvailableBookstores)}>
                    {t('bookstorefindit')}
                  </div>
                </Col>
              )} */}
              <Row>
                {isLogged && (
                  <Col lg={12} className="my-2 d-flex justify-content-center">
                    <Button
                      className={`text-uppercase product-${isBookFavorited?.status ? 'favorited' : 'no-favorited'}`}
                      onClick={isBookFavorited?.status ? removeBookFromFavoritesHandler : addBookToFavoritesHandler}
                    >
                      {isBookFavorited?.status ? t('eliminarFavoritos') : t('anadirFavoritos')}
                    </Button>
                  </Col>
                )}
              </Row>
              <Row className="mt-4 mx-1 detailRow">
                <p>{t('datosProducto')}</p>
                <ul>
                  {productDetail?.editorial ? (
                    <li>
                      <strong>{t('editorial')}: </strong>
                      <Link
                        to={`/${assignedLibrary}/editorial/${productDetail?.editorial.url}/`}
                        state={productDetail?.editorial.nombre_fiscal}
                      >
                        {productDetail.editorial.nombre_fiscal}
                      </Link>
                    </li>
                  ) : (
                    <p>
                      <strong>{t('editorial')}: </strong>
                      <span>{t('notSpecified')}</span>
                    </p>
                  )}
                  {productDetail?.ean && (
                    <li>
                      <strong>ISBN:</strong> <span className="text-datosProducto">{productDetail.ean}</span>
                    </li>
                  )}
                  {productDetail?.publication_date && (
                    <li>
                      <strong>{t('publicacion')}:</strong>{' '}
                      <span className="text-datosProducto">{productDetail.publication_date}</span>
                    </li>
                  )}
                  {productDetail?.encuadernacion && (
                    <li>
                      <strong>{t('formato')}:</strong>{' '}
                      <span className="text-datosProducto">{properties.processEncuadernacion(productDetail)}</span>
                    </li>
                  )}
                  {productDetail?.languages && (
                    <li>
                      <strong>{t('idioma')}:</strong>{' '}
                      <span className="text-datosProducto">{properties.processLan()}</span>
                    </li>
                  )}
                  {productDetail?.alto_cm && productDetail?.ancho_cm && productDetail?.grosor_cm && (
                    <li>
                      <strong>{t('dimensions')}:</strong>{' '}
                      <span className="text-datosProducto">
                        {`${productDetail?.alto_cm}cm x ${productDetail?.ancho_cm}cm x ${productDetail?.grosor_cm}cm`}
                      </span>
                    </li>
                  )}
                  {productDetail?.num_paginas && (
                    <li>
                      <strong>{t('numeroPagina')}:</strong>{' '}
                      <span className="text-datosProducto">{productDetail.num_paginas}</span>
                    </li>
                  )}
                  <div className="d-flex gap-2">
                    <strong>{t('subjects')}:</strong>
                    <div>
                      {productDetail?.materia_ibic?.length > 0 &&
                        productDetail?.materia_ibic.map((item, i) => (
                          <div key={i}>
                            <Link
                              className="store-item__link"
                              to={`/${assignedLibrary}/lista/materias?ibic=${item.id}&title=${encodeURIComponent(item.descripcion)}`}
                            >
                              {capitalize(item?.descripcion)}
                            </Link>
                            {i < productDetail.materia_ibic.length - 1 && ' ,'}
                          </div>
                        ))}
                    </div>
                  </div>
                </ul>
              </Row>
            </Col>
          </Row>
          <Row className="justify-content-center mt-4">
            <Col lg={11} className="w-100">
              {loadingRelatedProducts && !noResults ? (
                <div className="d-flex justify-content-center align-items-center">
                  <Spinner animation="border" role="status" />
                </div>
              ) : relatedProducts.length > 0 ? ( // Mostrar productos relacionados si están disponibles
                <section className="list-section">
                  <Row className="mb-4">
                    <Col xs={12} sm={12} className="px-0">
                      <h3>{t('otrosProductos')}</h3>
                    </Col>
                  </Row>
                  <Col xs={12} sm={12}>
                    <Carousel responsive={responsive} slidesToSlide={1} minimumTouchDrag={40} draggable swipeable>
                      {relatedProducts?.map((item, i) => (
                        <div key={`relatedProductsItem#${i}`} className="slide-div">
                          <ItemList data={item} />
                        </div>
                      ))}
                    </Carousel>
                  </Col>
                </section>
              ) : null}
            </Col>
          </Row>
          <AvailableLibraries
            hasStock={productDetail?.has_stock}
            showLibraries={showAvailableBookstores}
            closeOverlay={closeOverlay}
            libraries={availableLibraries}
          />
          <BookConditionChoiceModal
            show={!!pendingProduct}
            product={pendingProduct}
            onHide={closeModal}
            onConfirm={confirmCondition}
          />
        </Container>
      ) : (
        <NoResults className="noFavorites" />
      )}
    </div>
  );
}

export default BookDetail;
